module.exports = __webpack_public_path__ + "static/media/shop-icon.eb98f58e.svg";